import { render } from "./FolderFiles.vue?vue&type=template&id=5fb786d7"
import script from "./FolderFiles.vue?vue&type=script&lang=js"
export * from "./FolderFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__